import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Routes, Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import './globals.css'
import RootLayout from './layouts/RootLayout'
import { addOnPath, claimPath, mintPath, worksPath } from './lib/paths'

// Register pages for use with React router
import ClaimCustodialNFT from './pages/ClaimCustodialNFT'
import Dashboard from './pages/Dashboard'
import Mint from './pages/Mint'
import Work from './pages/Work'
import { ConnectWalletContextProvider } from '@verisart/nft/src'
import { initWalletConfig } from '@verisart/nft/src/ConnectWalletContextProvider'
import { OptimizelyProvider, createInstance } from '@optimizely/react-sdk'
import { logging } from '@optimizely/optimizely-sdk'
import AddOnRedirect from './pages/AddOnRedirect'
import { WalletProvider } from './context/wallet'
import { APIProvider } from './context/api'

const logLevel = 'ERROR'

export const optimizely = createInstance({
  sdkKey: process.env.REACT_APP_PUBLIC_OPTIMIZELY_SDK_KEY,
  logger: logging.createLogger({ logLevel }),
})

const App = () => {
  const queryClient = new QueryClient()
  return (
    <OptimizelyProvider optimizely={optimizely} user={{ id: 'anonymous' }}>
      <QueryClientProvider client={queryClient}>
        <ConnectWalletContextProvider
          config={initWalletConfig(
            process.env.REACT_APP_ALCHEMY_KEY as string,
            process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID as string,
            true
          )}
        >
          <APIProvider>
            <WalletProvider>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <Routes>
                  <Route path="/" element={<RootLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path={claimPath} element={<ClaimCustodialNFT />} />
                    <Route path={mintPath} element={<Mint />} />
                    <Route path={worksPath} element={<Work />} />
                    <Route path={addOnPath} element={<AddOnRedirect />} />
                  </Route>
                </Routes>
              </QueryParamProvider>
            </WalletProvider>
          </APIProvider>
        </ConnectWalletContextProvider>
      </QueryClientProvider>
    </OptimizelyProvider>
  )
}

export default App
